import BreadCrumbs from "../components/ui/BreadCrumbs";
import { Card } from "../components/ui/Card";
import { StyledSeperator } from "../components/ui/Seperator";
import { StyledInput } from "../components/ui/StyledInput";
import Title from "../components/ui/Title";
import {
    Box,
    FormLabel,
    Grid,
    MenuItem,
    Select,
    Typography,
    SelectChangeEvent
} from "@mui/material";
import { useEffect, useState } from "react";
import { fetchAwbno, fetchTicketCategory, TicketFormData, createTicket } from "../config/api";
import { StyledButton } from "../components/ui/StyledButton";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { TextArea } from "../components/ui/TextArea";

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

interface TicketCategoyrData {
    id: number;
    category: string;
}
interface AwbnoData {
    id: string;
    guid: string;
}

const Ticket = () => {
    const [awbno, setAwbno] = useState<AwbnoData[]>([])
    const [ticketCategory, setTicketCategory] = useState<TicketCategoyrData[]>([])

    const [formData, setFormData] = useState<TicketFormData>({
        awb_no: [],
        category: '',
        query_remark: '',

    });

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name } = event.target;
        setFormData({ ...formData, [name]: event.target.value });
    };

    useEffect(() => {
        fetchAwbno().then((data) => {
            setAwbno(data.data.data)
        }).catch((error) => { console.log(error); })

        fetchTicketCategory().then((data) => {
            setTicketCategory(data.data.data)
        }).catch((error) => {
            console.log();
        })

    }, []);

    const navigate = useNavigate();

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        var new_awbno = formData.awb_no

        formData.awb_no = []
        awbno.map((item) => {
            new_awbno.map((item2) => {
                if (item2 === item.id) {
                    formData.awb_no.push(item.id)
                }
            })
        })

        createTicket(formData).then(() => {
            toast.success("Ticket Add Successfully!. We will get back to you on Mail.");
            navigate(`/support-and-help/`)
        }).catch((error) => {
            console.log("error ", error);
            toast.error(error.message);
        });

    };

    return (
        <>
            <BreadCrumbs
                field="Support And Help"
                link={"/support-and-help"}
                extra={[
                    {
                        text: "Ticket",
                    },
                ]}
            />
            <Card>
                <Box
                    sx={{
                        margin: "10px 0",
                    }}
                >
                    <Box>
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Title title="Create Ticket" />
                            <StyledSeperator
                                style={{
                                    margin: "10px",
                                    width: "100%",
                                }}
                            />
                        </Grid>

                        <form onSubmit={handleSubmit}>
                            <Grid container mt={2}>
                                <Grid item xs={12} md={6} gap={4}>
                                    <Grid item xs={12} md={12} pb={2}>
                                        <Autocomplete
                                            multiple
                                            disablePortal
                                            options={awbno}
                                            getOptionLabel={(option) => option.guid}
                                            value={awbno.filter(item => formData.awb_no.includes(item.id))} // Filter selected items
                                            onChange={(event, newValue: AwbnoData[]) => {
                                                const selectedIds = newValue.map(item => item.id); // Extract IDs
                                                setFormData({ ...formData, awb_no: selectedIds }); // Update formData with IDs
                                            }}
                                            renderInput={(params) => <TextField {...params} label="AWB No" />}
                                            sx={{
                                                minWidth: '50%',
                                                // borderRadius: "16px",
                                                background: "#fff",
                                                boxShadow:
                                                    "-1px -1px 4px 0px rgb(255, 255, 255), 2px 2px 6px 0px rgba(0, 0, 0, 0.2) !important",
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12} pb={2}>
                                        <FormLabel>
                                            <Typography fontSize={15}>Ticket Category</Typography>
                                        </FormLabel>
                                        <Select
                                            value={formData.category}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    category: e.target.value,
                                                })
                                            }
                                            fullWidth
                                            sx={{
                                                minWidth: '50%',
                                                borderRadius: "16px",
                                                background: "#fff",
                                                boxShadow:
                                                    "-1px -1px 4px 0px rgb(255, 255, 255), 2px 2px 6px 0px rgba(0, 0, 0, 0.2) !important",
                                            }}
                                        >
                                            {ticketCategory.map((no) => (
                                                <MenuItem key={no.id} value={no.id}>
                                                    {no.category}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={12} md={12} pb={2}>
                                        <FormLabel>
                                            <Typography fontSize={15}>Remark</Typography>
                                        </FormLabel>
                                        <TextArea
                                            fullWidth
                                            onChange={handleInputChange}
                                            placeholder=""
                                            name="query_remark"
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={12} pb={2}>
                                        <StyledButton
                                            type="submit"
                                            variant="contained"
                                            fullWidth
                                        >
                                            Save
                                        </StyledButton>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>
                </Box>
            </Card>
        </>
    );
};

export default Ticket;
